// ENUMS
import { Status } from '../enums/proposal-status.enum';
import { Themes } from '../enums/themes';

export const convenantOptions = [
  { id: 1, name: 'Aposentados e Pensionistas INSS', label: 'Aposentados e Pensionistas INSS', active: true },
  { id: 2, name: 'Estado do Paraná', label: 'Estado do Paraná', active: true },
  { id: 3, name: 'Governo do Estado de Santa Catarina', label: 'Governo do Estado de Santa Catarina', active: true },
  { id: 4, name: 'Grupo Barigui', label: 'Grupo Barigui', active: true },
  { id: 5, name: 'Prefeitura de Curitiba', label: 'Prefeitura de Curitiba', active: true },
  { id: 6, name: 'Prefeitura de Florianópolis', label: 'Prefeitura de Florianópolis', active: true },
  {
    id: 7,
    name: 'Tribunal de Justiça do Estado do Paraná',
    label: 'Tribunal de Justiça do Estado do Paraná',
    active: true,
  },
  {
    id: 8,
    name: 'Tribunal de Contas do Estado do Paraná',
    label: 'Tribunal de Contas do Estado do Paraná',
    active: true,
  },
  {
    id: 9,
    name: 'Universidade Estadual de Ponta Grossa',
    label: 'Universidade Estadual de Ponta Grossa',
    active: true,
  },
  { id: 10, name: 'Universidade de Maringá', label: 'Universidade de Maringá', active: true },
  { id: 11, name: 'Universidade Oeste do Paraná', label: 'Universidade Oeste do Paraná', active: true },
  { id: 12, name: 'Siape Federal', label: 'Siape Federal', active: true },
  { id: 13, name: 'Antecipação saque-aniversário FGTS', label: 'Antecipação saque-aniversário FGTS', active: true },
  { id: 14, name: 'Cartão Benefício Estado do PR', label: 'Cartão Benefício Estado do PR', active: true },
  { id: 15, name: 'Crédito pessoal', label: 'Crédito pessoal', active: true },
  {
    id: 16,
    name: 'Cartão Benefício da Prefeitura de Curitiba',
    label: 'Cartão Benefício da Prefeitura de Curitiba',
    active: true,
  },
  {
    id: 17,
    name: 'Cartão Benefício da Prefeitura de Florianópolis',
    label: 'Cartão Benefício da Prefeitura de Florianópolis',
    active: true,
  },
  { id: 18, name: 'Cartão Benefício INSS', label: 'Cartão Benefício INSS', active: true },
  { id: 19, name: 'Cartão Benefício INSS RCC', label: 'Cartão Benefício INSS RCC', active: true },
  { id: 20, name: 'Cartão Benefício INSS RMC', label: 'Cartão Benefício INSS RMC', active: true },
];

export const statusOptions = [
  { id: 0, badgeType: Themes.WARNING, name: Status.CREATED, label: 'Proposta Criada.', active: true },
  {
    id: 1,
    badgeType: Themes.PRIMARY,
    name: Status.AWAITING_SIGNATURE,
    label: 'Aguardando ass.',
    active: true,
  },
  { id: 2, badgeType: Themes.PRIMARY, name: Status.AWAITING_CONDITIONS, label: 'Aguardando Cond.', active: true },
  {
    id: 3,
    badgeType: Themes.PRIMARY,
    name: Status.AWAITING_CHECKING_ACCOUNT,
    label: 'Aguardando Conta.',
    active: true,
  },
  {
    id: 4,
    badgeType: Themes.DEFAULT,
    name: Status.FORMALIZATION,
    label: 'Em análise.',
    active: true,
  },
  {
    id: 5,
    badgeType: Themes.SECONDARY,
    name: Status.MADE_EFFECTIVE,
    label: 'Efetivado.',
    active: true,
  },
  {
    id: 6,
    badgeType: Themes.INFO,
    name: Status.REJECTED,
    label: 'Negado.',
    active: true,
  },
  {
    id: 7,
    badgeType: Themes.WARNING,
    name: Status.PENDING_DOCUMENTS,
    label: 'Pendência Doc.',
    active: true,
  },
  {
    id: 8,
    badgeType: Themes.WARNING,
    name: Status.PENDING_SIGN,
    label: 'Pendência Ass.',
    active: true,
  },
  {
    id: 9,
    badgeType: Themes.WARNING,
    name: Status.PENDING_DOCUMENTS_SIGN,
    label: 'Pendências.',
    active: true,
  },
  {
    id: 10,
    badgeType: Themes.INFO,
    name: Status.REFUSED,
    label: 'Recusado.',
    active: true,
  },
  {
    id: 11,
    badgeType: Themes.DEFAULT,
    name: Status.ENDORSED,
    label: 'Em Análise.',
    active: true,
  },
  {
    id: 12,
    badgeType: Themes.WARNING,
    name: Status.PENDING_PURCHASE_MARGIN,
    label: 'Pendência Margem',
    active: true,
  },
  {
    id: 13,
    badgeType: Themes.WARNING,
    name: Status.PENDING_PURCHASE_MARGIN_WRONG_PROPOSAL,
    label: 'Margem Prop. Errada',
    active: true,
  },
  {
    id: 14,
    badgeType: Themes.DEFAULT,
    name: Status.REFUSED_EXPIRED,
    label: 'Expirado',
    active: true,
  },
];
